export class Errors {
  static REFRESH_LOGIN_TOKENS = 'An error occurred trying to refresh the login tokens.';
  static REFRESH_TOKENS_EXPIRED = 'The refresh token has expired.';
  static PUBLISH_METRIC = 'An error occurred trying to publish a metric.';
}
